const white = "rgba(255, 255, 255, 1)";

export const lightLayer = {
    "floor-0": white,
    "floor-0-grouped": "rgba(238, 241, 240, 1)",
    "floor-1": white,
    "floor-2": white,
    "floor-3": white,
    surface: "rgba(0, 45, 30, 0.07)",
    "surface-inner-shadow": white,
};

export const lightContent = {
    primary: "rgba(25, 31, 28, 1)",
    secondary: "rgba(0, 10, 7, 0.63)",
    tertiary: "rgba(0, 17, 11, 0.47)",
    "action-primary": "rgba(0, 112, 66, 0.92)",
    "action-secondary": "rgba(0, 110, 55, 0.83)",
    "danger-primary": "rgba(173, 0, 14, 0.94)",
    "danger-secondary": "rgba(218, 0, 18, 0.9)",
    "warning-primary": "rgba(158, 91, 0, 1)",
    "warning-secondary": "rgba(255, 178, 0, 1)",
    "positive-primary": "rgba(0, 112, 66, 0.92)",
    "positive-secondary": "rgba(0, 110, 55, 0.83)",
    "promo-primary": "rgba(56, 4, 215, 0.94)",
    "promo-secondary": "rgba(0, 20, 237, 0.65)",
    "link-primary": "rgba(0, 112, 66, 0.92)",
    "link-secondary": "rgba(0, 110, 55, 0.83)",
    "primary-inverted": "rgba(253, 255, 254, 0.93)",
    "secondary-inverted": "rgba(244, 254, 249, 0.69)",
    "action-primary-inverted": "rgba(116, 239, 170, 1)",
    "action-secondary-alternative": "rgba(0, 110, 55, 0.83)",
};

export const lightBg = {
    "neutral-primary": "rgba(14, 16, 16, 1)",
    "neutral-secondary": "rgba(0, 45, 30, 0.07)",
    "neutral-secondary-hard": "rgba(0, 20, 13, 0.16)",
    "action-primary": "rgba(43, 134, 89, 1)",
    "action-secondary": "rgba(0, 160, 64, 0.09)",
    "danger-primary": "rgba(222, 25, 41, 1)",
    "danger-secondary": "rgba(255, 0, 0, 0.08)",
    "warning-primary": "rgba(255, 178, 0, 1)",
    "warning-secondary": "rgba(255, 190, 0, 0.23)",
    "positive-primary": "rgba(43, 134, 89, 1)",
    "positive-secondary": "rgba(0, 160, 64, 0.09)",
    "promo-primary": "rgba(89, 102, 243, 1)",
    "promo-secondary": "rgba(0, 60, 255, 0.07)",
};

export const lightSpecial = {
    bg: {
        disabled: "rgba(0, 45, 30, 0.07)",
        zebra: "rgba(0, 64, 32, 0.03)",
    },
    nulled: "rgba(0, 0, 0, 0.0)",
    scrim: "rgba(0, 0, 0, 0.28)",
    "special-brand": "rgba(42, 156, 100, 1)",
    "special-brand-alt": "rgba(12, 44, 28, 1)",
};

export const lightBorder = {
    "neutral-primary": "rgba(0, 17, 11, 0.47)",
    "neutral-secondary": "rgba(0, 20, 13, 0.16)",
    separator: "rgba(0, 45, 30, 0.07)",
    "action-primary": "rgba(43, 134, 89, 1)",
    "action-secondary": "rgba(1, 133, 52, 0.29)",
    "danger-primary": "rgba(222, 25, 41, 1)",
    "danger-secondary": "rgba(255, 0, 4, 0.26)",
    "warning-primary": "rgba(255, 178, 0, 1)",
    "warning-secondary": "rgba(255, 164, 0, 0.55)",
    "positive-primary": "rgba(43, 134, 89, 1)",
    "positive-secondary": "rgba(1, 133, 52, 0.29)",
    "promo-primary": "rgba(89, 102, 243, 1)",
    "promo-secondary": "rgba(0, 55, 255, 0.24)",
};

export const lightBgActive = {
    "neutral-primary": "rgba(22, 26, 24, 1)",
    "neutral-secondary": "rgba(0, 31, 24, 0.13)",
    "neutral-secondary-hard": "rgba(0, 15, 11, 0.28)",
    "action-primary": "rgba(24, 120, 76, 1)",
    "action-secondary": "rgba(0, 144, 56, 0.22)",
    "danger-primary": "rgba(206, 0, 25, 1)",
    "danger-secondary": "rgba(255, 0, 0, 0.2)",
    "warning-primary": "rgba(255, 161, 0, 1)",
    "warning-secondary": "rgba(255, 173, 0, 0.44)",
    "positive-primary": "rgba(24, 120, 76, 1)",
    "positive-secondary": "rgba(0, 144, 56, 0.22)",
    "promo-primary": "rgba(79, 91, 218, 1)",
    "promo-secondary": "rgba(0, 58, 255, 0.17)",
};

export const lightBorderActive = {
    "neutral-primary": "rgba(0, 16, 10, 0.51)",
    "neutral-secondary": "rgba(0, 15, 11, 0.28)",
    "action-primary": "rgba(24, 120, 76, 1)",
    "danger-primary": "rgba(206, 0, 25, 1)",
    "link-primary": "rgba(8, 31, 20, 1)",
    "action-primary-inverted": "rgba(221, 255, 233, 1)",
};

export const lightContentActive = {
    "link-primary": "rgba(8, 31, 20, 1)",
    "action-primary-inverted": "rgba(221, 255, 233, 1)",
};

export const staticContent = {
    "key-dark": "rgba(0, 0, 0, 1)",
    "primary-dark": "rgba(25, 31, 28, 1)",
    "secondary-dark": "rgba(0, 10, 7, 0.63)",
    "tertiary-dark": "rgba(0, 17, 11, 0.47)",
    "key-light": "rgba(255, 255, 255, 1)",
    "primary-light": "rgba(236, 238, 237, 1)",
    "secondary-light": "rgba(244, 254, 249, 0.69)",
    "tertiary-light": "rgba(225, 253, 241, 0.4)",
};

export const staticBg = {
    "key-light": "rgba(255, 255, 255, 1)",
    "natural-secondary-light": "rgba(244, 246, 233, 0.08)",
    "key-dark": "rgba(0, 0, 0, 1)",
    "key-secondary-dark": "rgba(0, 45, 30, 0.07)",
    "neutral-primary-dark": "rgba(32, 34, 33, 1)",
    "promo-high-contrast": "rgba(43, 134, 89, 1)",
    "danger-high-contrast": "rgba(222, 25, 41, 1)",
    "active-key-light": "rgba(247, 249, 248, 1)",
};

export const boxShadow = {
    "elevation-1": "0px 2px 6px 0px rgba(0, 0, 0, 0.16)",
    "elevation-2": "0px 4px 12px 0px rgba(0, 0, 0, 0.2)",
    "elevation-3": "0px 6px 24px 0px rgba(0, 0, 0, 0.24)",
};
